import { createContext } from 'react';

// creating context in a separate file to avoid circular imports
export default createContext(null);



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ForemanModal/ForemanModalContext.js